if (!customElements.get('scroll-indicator')) {
  class ScrollIndicator extends HTMLElement {
    connectedCallback() {
      this.btn = this.querySelector('.scroll-indicator__btn');
      if (!this.btn) return;

      this.#updateVisibility();
      this.#onScroll = this.#updateVisibility.bind(this);
      window.addEventListener('scroll', this.#onScroll, { passive: true });
      this.btn.addEventListener('click', () => this.#scrollToNext());
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.#onScroll);
    }

    #onScroll = null;
    #scrolling = false;

    #updateVisibility() {
      this.classList.toggle('is-hidden', window.scrollY > window.innerHeight * 0.25);
    }

    #scrollToNext() {
      if (this.#scrolling) return;
      this.#scrolling = true;

      const sections = [...document.querySelectorAll('#MainContent > *')];
      let currentIdx = -1;
      sections.forEach((el, idx) => {
        if (el.getBoundingClientRect().top <= 0) currentIdx = idx;
      });

      const target = sections[Math.max(currentIdx, 0) + 1];

      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        window.scrollBy({ top: window.innerHeight, behavior: 'smooth' });
      }

      setTimeout(() => { this.#scrolling = false; }, 800);
    }
  }

  customElements.define('scroll-indicator', ScrollIndicator);
}
